import React from "react";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useContacts } from "../hooks";

interface IProps {
  customerId: number;
}

export const ContactsList: React.FC<IProps> = ({ customerId }) => {
  const navigate = useNavigate();
  const { data, loading } = useContacts({ where: { customerId } });

  if (loading) return <Loading />;

  if (!data?.contacts?.results?.length) {
    return <EmptyList text="Aucun contact" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>Nom</TableCell>
          <TableCell header>Poste</TableCell>
          <TableCell header align="center">
            Principal
          </TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.contacts?.results?.map((contact) => (
          <TableRow
            key={`contact-${contact.id}`}
            onClick={() => navigate(`/contact/${contact.id}`)}
          >
            <TableCell>
              {contact.firstname} {contact.lastname}
            </TableCell>
            <TableCell>{contact.jobTitle?.name}</TableCell>
            <TableCell align="center">{contact.isPrimary ? "Oui" : "Non"}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
